import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { of, switchMap } from 'rxjs';

import { LoginService } from '../login/login.service';
import { ROUTE_CONSTANTS } from '../../util/route.constants';

export const AuthGuard: CanActivateFn | CanActivateChildFn = () => {
  const router = inject(Router);
  const loginService = inject(LoginService);

  return loginService
    .isLoggedIn()
    .pipe(
      switchMap((authenticated) => {
        if (authenticated) {
          if (!loginService.loggedIn$.value) {
            loginService.loggedIn$.next(true);
          }
          return of(true);
        } else {
          const urlTree = router.parseUrl(`${ROUTE_CONSTANTS.LOGIN}`);
          return of(urlTree);
        }
      })
    );
};
